/**
 * @namespace source.folder
 */
/**
 * @typedef Folder
 * @type Object
 * @property {string} id
 * @property {string} name
 * @property {string} mediaType
 * @property {number} filesCount
 * @property {date} createdAt
 */
import { toFolder } from './mappers/folder';
import { toError } from './parsers/error';
import { decodeItemId } from './parsers/item-id';
export function initFolder(settings, http, privateSiteFolder) {
  /**
   * @summary Returns folder
   * @memberof source.folder
   * @param {String} folderId
   * @param {Object} [options]
   * @returns {Promise}
   * @fulfill {Item}
   * @reject {Error}
   */
  function getRequest(folderId) {
    const {
      id,
      siteMediaToken
    } = decodeItemId(folderId);
    if (!siteMediaToken) {
      return Promise.resolve({
        data: {}
      });
    }
    const queryParams = {
      siteMediaToken
    };
    if (settings.namespace) {
      queryParams.ns = settings.namespace;
    }
    return privateSiteFolder.get(id, queryParams).then(response => ({
      ...response,
      data: toFolder(response.data, folderId)
    })).catch(toError);
  }
  return {
    get: getRequest
  };
}